import { css } from 'styled-components';
export const withColors = ({ color }) => {
    if (!color)
        return css ``;
    return css `
    color: var(${color});
  `;
};
